export const createActionMatcher = (logger) => {
    const actionMap = {};
    const matcher = {
        match: (actionType, biEvent, getEventParams) => {
            actionType.forEach((actionType) => {
                if (actionMap[actionType]) {
                    throw new Error(`Action matcher for ${actionType} already exists`);
                }
                else {
                    actionMap[actionType] = (action) => biEvent(getEventParams(action));
                }
            });
            return matcher;
        },
        execute: (action) => {
            const eventParamCallback = actionMap[action.type];
            const eventParams = eventParamCallback ? eventParamCallback(action) : null;
            if (eventParams) {
                logger.report(eventParams);
            }
        },
    };
    return matcher;
};
//# sourceMappingURL=create-action-matcher.js.map